import React from "react";

function cn(...c) {
  return c.filter(Boolean).join(" ");
}

const VARIANTS = {
  primary:
    "bg-primary text-white border border-primary hover:brightness-110 active:brightness-95",
  outline:
    "bg-transparent text-primary border border-primary hover:bg-primary/10 dark:hover:bg-primary/15",
  ghost:
    "bg-transparent text-slate-800 dark:text-slate-100 border border-transparent hover:bg-slate-100 dark:hover:bg-slate-800/60",
};

const SIZES = {
  sm: "px-3 py-1.5 text-sm rounded-2xl",
  md: "px-4 py-2 text-sm rounded-3xl",
  lg: "px-5 py-2.5 text-base rounded-3xl",
};

const Button = ({
  text,
  onClick,
  icon: Icon,
  className = "",
  hoverLabel = "",

  // New API (optionnel)
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,

  // a11y extra
  ariaExpanded,
  ariaControls,
  type = "button",
}) => {
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      aria-label={hoverLabel || text}
      title={hoverLabel || text}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      className={cn(
        "inline-flex items-center justify-center gap-2 font-semibold",
        "transition duration-200 motion-reduce:transition-none",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60",
        "focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-slate-950",
        "shadow-sm hover:shadow-md",
        "disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:shadow-sm",
        VARIANTS[variant] || VARIANTS.primary,
        SIZES[size] || SIZES.md,
        className
      )}
    >
      {loading && (
        <span
          className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
          aria-hidden="true"
        />
      )}
      {Icon && !loading && <Icon className="text-lg" aria-hidden="true" />}
      {text}
    </button>
  );
};

export default Button;
